/**
 * Runs `fn`, returning `fallback` instead of throwing. Storage/matchMedia
 * access throws in private browsing and locked-down browsers, so every
 * caller of `localStorage`/`matchMedia` across the app goes through this
 * rather than trusting the environment to have them.
 */
export function safe<T>(fn: () => T, fallback: T): T {
  try {
    return fn();
  } catch {
    return fallback;
  }
}
